import AspectRatio from "./AspectRatio";
export default AspectRatio;
